import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { Menu, Dropdown, Button } from "antd";
import { PlusOutlined, DeleteOutlined, CloseCircleOutlined, PlusCircleOutlined, PlusCircleFilled } from "@ant-design/icons";
import { Expression, ExpressionWrapper, isLogicalExpression, isUnaryLogicalExpression } from "../types2";
import { ExpressionRenderer } from "./ExpressionRenderer";
import BuilderInteractor from "../builder.interactor";

export const LogicalExpression: React.FC<{
  expr: Expression;
  path: string[];
  interactor: BuilderInteractor;
}> = observer(({ expr, path, interactor }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const addExpression = (type: string) => {
    console.log("addExpression", [...path, "operands"]);
    interactor.addOperand([...path, "operands"], type);
  };

  const removeLogicalOperator = () => {
    if (isLogicalExpression(expr)) {
      if (expr.operands && expr.operands.length === 1) {
        // If there's only one operand, replace this logical expression with its operand
        interactor.updateExpression(path, expr.operands[0]);
      } else if (!expr.operands || expr.operands.length === 0) {
        // If there are no operands, replace with an empty object
        interactor.updateExpression(path, {});
      }
    }
  };

  // Check if this is a root level logical expression
  const isRootLevel = path.length === 0;

  const menu = (
    <Menu>
      <Menu.Item key="AND" onClick={() => addExpression("AND")}>
        AND
      </Menu.Item>
      <Menu.Item key="OR" onClick={() => addExpression("OR")}>
        OR
      </Menu.Item>
      <Menu.Item key="CASE" onClick={() => addExpression("CASE")}>
        CASE
      </Menu.Item>
      <Menu.Item
        key="Literal Value"
        onClick={() => addExpression("literalValue")}
      >
        Literal Value
      </Menu.Item>
      <Menu.Item
        key="Data Field Path"
        onClick={() => addExpression("DataFieldPath")}
      >
        Data Field Path
      </Menu.Item>
      <Menu.Item key="Functions" onClick={() => addExpression("Functions")}>
        Functions
      </Menu.Item>
      <Menu.Item
        key="Unary Arithmetic"
        onClick={() => addExpression("UnaryArithmetic")}
      >
        Unary Arithmetic
      </Menu.Item>
    </Menu>
  );

  if (isLogicalExpression(expr)) {
    return (
      <div className="collapsible-expression">
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <div
            className={`collapse-icon ${isCollapsed ? "" : "minus"}`}
            onClick={() => setIsCollapsed(!isCollapsed)}
          />
          <span className="sql-keyword">
            <select
              onChange={(e) => interactor.updateOperator(path, e.target.value)}
              className="operator-select"
              value={expr.operator}
            >
              <option value="AND">AND</option>
              <option value="OR">OR</option>
            </select>
          </span>
          {isRootLevel && (!expr.operands || expr.operands.length < 1) && (
            <CloseCircleOutlined 
              onClick={removeLogicalOperator}
              style={{ color: '#ff4d4f', cursor: 'pointer' }}
            />
          )}
        </div>
        {!isCollapsed && (
          <div className="expression-content">
            {expr.operands &&
              expr.operands.map((operand: any, index) => (
                <div className="operands-container" key={index} style={{ marginTop: "4px" }}>
                    <div className="unary-logical-expression">
                        <input type="checkbox" checked={operand.operator === "NOT"} onChange={() => interactor.toggleUnaryLogicalObject([...path, "operands", index.toString()])} /> 
                    </div>
                  <ExpressionRenderer
                    expr={operand}
                    path={[...path, "operands", index.toString()]}
                    interactor={interactor}
                    requiredExpMenu={true}
                  />
                  <div>
                    <DeleteOutlined onClick={() => interactor.removeOperand([...path, "operands"], index)} />
                  </div>
                </div>
              ))}
            <div className="add-expression-button">
            <Dropdown overlay={menu} trigger={["click"]}>
            <PlusCircleFilled />
            </Dropdown>
            </div>
          </div>
        )}
      </div>
    );
  } else {
    return (
      <span className="sql-error">
        Unknown Expression Type: {JSON.stringify(expr)}
      </span>
    );
  }
}); 